"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: underwriting/product-eligibility-info.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Funderwriting%2Fproduct-eligibility-info.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductEligibilityInfo = void 0;
const amount_1 = require("../common/amount");
const borrow_block_reason_1 = require("../common/borrow-block-reason");
const lending_eligibility_1 = require("../common/lending-eligibility");
const evaluation_results_1 = require("./evaluation-results");
const product_eligibility_source_1 = require("./product-eligibility-source");
const product_type_1 = require("./product-type");
const protobufPackage = 'com.step.underwriting.common.proto';
function createBaseProductEligibilityInfo() {
    return {
        userId: '',
        productType: product_type_1.ProductType.INVALID_PRODUCT_TYPE,
        source: product_eligibility_source_1.ProductEligibilitySource.UNKNOWN_ELIGIBILITY_SOURCE,
        eligibility: lending_eligibility_1.LendingEligibility.fromPartial({}),
        overrideAmount: undefined,
        blockReasons: [],
        fromBatch: false,
        evaluationResult: undefined,
        createdAtMs: '0',
        updatedAtMs: '0',
    };
}
exports.ProductEligibilityInfo = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            productType: isSet(object.productType)
                ? (0, product_type_1.productTypeFromJSON)(object.productType)
                : product_type_1.ProductType.INVALID_PRODUCT_TYPE,
            eligibility: isSet(object.eligibility)
                ? lending_eligibility_1.LendingEligibility.fromJSON(object.eligibility)
                : lending_eligibility_1.LendingEligibility.fromPartial({}),
            blockReasons: globalThis.Array.isArray(object?.blockReasons)
                ? object.blockReasons.map((e) => (0, borrow_block_reason_1.borrowBlockReasonFromJSON)(e))
                : [],
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            updatedAtMs: isSet(object.updatedAtMs) ? globalThis.String(object.updatedAtMs) : '0',
        };
        if (isSet(object.source)) {
            message.source = (0, product_eligibility_source_1.productEligibilitySourceFromJSON)(object.source);
        }
        if (isSet(object.overrideAmount)) {
            message.overrideAmount = amount_1.Amount.fromJSON(object.overrideAmount);
        }
        if (isSet(object.fromBatch)) {
            message.fromBatch = globalThis.Boolean(object.fromBatch);
        }
        if (isSet(object.evaluationResult)) {
            message.evaluationResult = evaluation_results_1.EvaluationResult.fromJSON(object.evaluationResult);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.productType !== product_type_1.ProductType.INVALID_PRODUCT_TYPE) {
            obj.productType = (0, product_type_1.productTypeToJSON)(message.productType);
        }
        if (message.source !== undefined &&
            message.source !== product_eligibility_source_1.ProductEligibilitySource.UNKNOWN_ELIGIBILITY_SOURCE) {
            obj.source = (0, product_eligibility_source_1.productEligibilitySourceToJSON)(message.source);
        }
        if (message.eligibility !== undefined) {
            obj.eligibility = lending_eligibility_1.LendingEligibility.toJSON(message.eligibility);
        }
        if (message.overrideAmount !== undefined) {
            obj.overrideAmount = amount_1.Amount.toJSON(message.overrideAmount);
        }
        if (message.blockReasons?.length) {
            obj.blockReasons = message.blockReasons.map((e) => (0, borrow_block_reason_1.borrowBlockReasonToJSON)(e));
        }
        if (message.fromBatch !== undefined && message.fromBatch !== false) {
            obj.fromBatch = message.fromBatch;
        }
        if (message.evaluationResult !== undefined) {
            obj.evaluationResult = evaluation_results_1.EvaluationResult.toJSON(message.evaluationResult);
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.ProductEligibilityInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProductEligibilityInfo();
        message.userId = object.userId ?? '';
        message.productType = object.productType ?? product_type_1.ProductType.INVALID_PRODUCT_TYPE;
        message.source = object.source ?? product_eligibility_source_1.ProductEligibilitySource.UNKNOWN_ELIGIBILITY_SOURCE;
        message.eligibility = (object.eligibility !== undefined && object.eligibility !== null)
            ? lending_eligibility_1.LendingEligibility.fromPartial(object.eligibility)
            : lending_eligibility_1.LendingEligibility.fromPartial({});
        message.overrideAmount = (object.overrideAmount !== undefined && object.overrideAmount !== null)
            ? amount_1.Amount.fromPartial(object.overrideAmount)
            : undefined;
        message.blockReasons = object.blockReasons?.map((e) => e) || [];
        message.fromBatch = object.fromBatch ?? false;
        message.evaluationResult =
            (object.evaluationResult !== undefined && object.evaluationResult !== null)
                ? evaluation_results_1.EvaluationResult.fromPartial(object.evaluationResult)
                : undefined;
        message.createdAtMs = object.createdAtMs ?? '0';
        message.updatedAtMs = object.updatedAtMs ?? '0';
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=product-eligibility-info.js.map